import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import { useGetInstance } from "src/api/General/instance";
import { useGetSettings } from "src/api/General/settings";
import { Badge } from "src/components/ui/badge";
import { Button } from "src/components/ui/button";
import { Loading } from "src/components/ui/loading";
import { useRealmApp } from "src/store/RealmApp";

export default function Integrations() {
  const { data: settings } = useGetSettings();
  const { instance } = useGetInstance();
  return (
    <div className="flex h-full flex-col">
      <div className="flex h-12 items-center border-b border-gray-200/70 px-8 text-sm">
        <div className="flex items-center space-x-2 text-sm">
          <Link to={`/settings`}>
            <div className="text-gray-800">{instance?.name}</div>
          </Link>
          <ChevronRightIcon className="h-3 w-3 text-gray-500" />
          <div className="cursor-default text-gray-800">{"Integrations"}</div>
        </div>
      </div>
      <div className="flex-1 overflow-auto">
        <div className="mx-auto max-w-2xl pt-20">
          <div className="space-y-1 border-gray-200/70 pb-2">
            <div className="text-xl font-medium">Integrations</div>
            <div className="text-sm font-light text-gray-600">
              Connect Sero with your essential tools to create powerful
              workflows
            </div>
          </div>
          <div className="mt-8">
            {!!settings ? (
              <div className="grid grid-cols-2 gap-4">
                <IntegrationCard
                  Icon={
                    <svg
                      width="22px"
                      height="22px"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                    >
                      <g fill-rule="evenodd" clip-rule="evenodd">
                        <path
                          fill="#E01E5A"
                          d="M2.471 11.318a1.474 1.474 0 001.47-1.471v-1.47h-1.47A1.474 1.474 0 001 9.846c.001.811.659 1.469 1.47 1.47zm3.682-2.942a1.474 1.474 0 00-1.47 1.471v3.683c.002.811.66 1.468 1.47 1.47a1.474 1.474 0 001.47-1.47V9.846a1.474 1.474 0 00-1.47-1.47z"
                        />
                        <path
                          fill="#36C5F0"
                          d="M4.683 2.471c.001.811.659 1.469 1.47 1.47h1.47v-1.47A1.474 1.474 0 006.154 1a1.474 1.474 0 00-1.47 1.47zm2.94 3.682a1.474 1.474 0 00-1.47-1.47H2.47A1.474 1.474 0 001 6.153c.002.812.66 1.469 1.47 1.47h3.684a1.474 1.474 0 001.47-1.47z"
                        />
                        <path
                          fill="#2EB67D"
                          d="M9.847 7.624a1.474 1.474 0 001.47-1.47V2.47A1.474 1.474 0 009.848 1a1.474 1.474 0 00-1.47 1.47v3.684c.002.81.659 1.468 1.47 1.47zm3.682-2.941a1.474 1.474 0 00-1.47 1.47v1.47h1.47A1.474 1.474 0 0015 6.154a1.474 1.474 0 00-1.47-1.47z"
                        />
                        <path
                          fill="#ECB22E"
                          d="M8.377 9.847c.002.811.659 1.469 1.47 1.47h3.683A1.474 1.474 0 0015 9.848a1.474 1.474 0 00-1.47-1.47H9.847a1.474 1.474 0 00-1.47 1.47zm2.94 3.682a1.474 1.474 0 00-1.47-1.47h-1.47v1.47c.002.812.659 1.469 1.47 1.47a1.474 1.474 0 001.47-1.47z"
                        />
                      </g>
                    </svg>
                  }
                  name={"Slack"}
                  description={
                    "Receive updates from Sero projects in your Slack channels or via the Sero Slack app."
                  }
                  route={"/settings/integrations/slack"}
                />
                <IntegrationCard
                  Icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22px"
                      height="22px"
                      viewBox="0 0 24 24"
                      fill="#f57722"
                    >
                      <path
                        fill="#f57722"
                        d="M17.1 8.6V6.2c.6-.3 1.1-.9 1.1-1.6v-.1c0-1-.8-1.8-1.8-1.8h-.1c-1 0-1.8.8-1.8 1.8v.1c0 .7.4 1.3 1.1 1.6v2.4c-.9.1-1.8.5-2.5 1.1L6.5 4.6c.3-1.1-.4-2.3-1.5-2.5s-2.2.3-2.5 1.4s.4 2.3 1.5 2.6c.5.1 1.1.1 1.6-.2l6.4 5c-1.2 1.8-1.2 4.1.1 5.9l-2 2c-.2 0-.3-.1-.5-.1c-.9 0-1.7.8-1.7 1.7S8.7 22 9.6 22s1.7-.8 1.7-1.7c0-.2 0-.3-.1-.5l1.9-1.9c2.3 1.7 5.6 1.3 7.3-1s1.3-5.6-1-7.3c-.6-.5-1.4-.9-2.3-1m-.8 7.8c-1.5 0-2.7-1.2-2.7-2.7s1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7s-1.2 2.7-2.7 2.7"
                      />
                    </svg>
                  }
                  name={"HubSpot"}
                  description={
                    "Trigger projects in Sero when a deal closes in HubSpot."
                  }
                  route={"/settings/integrations/hubspot"}
                  disabled={!settings?.view.integrations.crm}
                />
                <IntegrationCard
                  Icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18px"
                      height="18px"
                      viewBox="0 0 256 256"
                    >
                      <path
                        fill="#fff"
                        d="M195.368 60.632H60.632v134.736h134.736z"
                      ></path>
                      <path
                        fill="#ea4335"
                        d="M195.368 256L256 195.368l-30.316-5.172l-30.316 5.172l-5.533 27.73z"
                      ></path>
                      <path
                        fill="#188038"
                        d="M0 195.368v40.421C0 246.956 9.044 256 20.21 256h40.422l6.225-30.316l-6.225-30.316l-33.033-5.172z"
                      ></path>
                      <path
                        fill="#1967d2"
                        d="M256 60.632V20.21C256 9.044 246.956 0 235.79 0h-40.422q-5.532 22.554-5.533 33.196q0 10.641 5.533 27.436q20.115 5.76 30.316 5.76T256 60.631"
                      ></path>
                      <path
                        fill="#fbbc04"
                        d="M256 60.632h-60.632v134.736H256z"
                      ></path>
                      <path
                        fill="#34a853"
                        d="M195.368 195.368H60.632V256h134.736z"
                      ></path>
                      <path
                        fill="#4285f4"
                        d="M195.368 0H20.211C9.044 0 0 9.044 0 20.21v175.158h60.632V60.632h134.736z"
                      ></path>
                      <path
                        fill="#4285f4"
                        d="M88.27 165.154c-5.036-3.402-8.523-8.37-10.426-14.94l11.689-4.816q1.59 6.063 5.558 9.398c2.627 2.223 5.827 3.318 9.566 3.318q5.734 0 9.852-3.487c2.746-2.324 4.127-5.288 4.127-8.875q0-5.508-4.345-8.994c-2.897-2.324-6.535-3.486-10.88-3.486h-6.754v-11.57h6.063q5.608 0 9.448-3.033c2.56-2.02 3.84-4.783 3.84-8.303c0-3.132-1.145-5.625-3.435-7.494c-2.29-1.87-5.188-2.813-8.708-2.813c-3.436 0-6.164.91-8.185 2.745a16.1 16.1 0 0 0-4.413 6.754l-11.57-4.817c1.532-4.345 4.345-8.185 8.471-11.503s9.398-4.985 15.798-4.985c4.733 0 8.994.91 12.767 2.745c3.772 1.836 6.736 4.379 8.875 7.613c2.14 3.25 3.2 6.888 3.2 10.93c0 4.126-.993 7.613-2.98 10.476s-4.43 5.052-7.327 6.585v.69a22.25 22.25 0 0 1 9.398 7.327c2.442 3.284 3.672 7.208 3.672 11.79c0 4.58-1.163 8.673-3.487 12.26c-2.324 3.588-5.54 6.417-9.617 8.472c-4.092 2.055-8.69 3.1-13.793 3.1c-5.912.016-11.369-1.685-16.405-5.087m71.797-58.005l-12.833 9.28l-6.417-9.734l23.023-16.607h8.825v78.333h-12.598z"
                      ></path>
                    </svg>
                  }
                  name={"Google Calendar"}
                  description={
                    "Get calendar events to automate time tracking."
                  }
                  // description={
                  //   "Sync calendar events to enable our AI Note Taker to join meetings and to make time tracking simpler."
                  // }
                  route={"/settings/integrations/google-calendar"}
                  disabled={false}
                />
              </div>
            ) : (
              <Loading className="mt-20" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export function BackToIntegrationsButton() {
  const navigate = useNavigate();
  return (
    <Button
      className="space-x-2 px-0 font-normal text-gray-500"
      variant={"secondaryLink"}
      onClick={() => {
        navigate("/settings/integrations");
      }}
    >
      <ChevronLeftIcon className="h-3.5 w-3.5" />
      <span>Integrations</span>
    </Button>
  );
}

function IntegrationCard({
  name,
  Icon,
  description,
  route,
  disabled,
  active,
}: {
  name: string;
  Icon: React.ReactNode;
  description: string;
  route: string;
  disabled?: boolean;
  active?: boolean;
}) {
  const navigate = useNavigate();
  return (
    <div
      className={clsx(
        "h-[146px] space-y-2.5 rounded-md border p-6 shadow-sm",
        disabled ? "cursor-not-allowed" : "cursor-pointer hover:bg-gray-50"
      )}
      onClick={() => {
        if (!disabled) {
          navigate(route);
        }
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {Icon}
          <div className="font-medium leading-none">{name}</div>
        </div>
        {disabled ? (
          <Badge variant={"gray"}>Disabled</Badge>
        ) : active ? (
          <Badge variant={"green"}>Active</Badge>
        ) : null}
      </div>
      <div className="text-sm font-light leading-relaxed text-gray-600">
        {description}
      </div>
    </div>
  );
}

function HubSpotTicketsButton() {
  const app = useRealmApp();
  // const redirect_uri = `${process.env.REACT_APP_URL}/settings/slack/authentication`;
  const url = `https://app.hubspot.com/oauth/authorize?client_id=b67334cc-ff9c-450c-94f4-fd2b34d2ff2d&redirect_uri=${process.env.REACT_APP_URL}/settings/hubspot/authentication&scope=tickets`;

  return (
    <button className="rounded-md border border-gray-300 px-2 py-2">
      <a href={url} className="flex items-center justify-center space-x-2">
        <img
          alt="Add to HubSpot"
          className="h-5"
          // width="139"
          src="/static/hubspot.svg"
          // srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
        />
        <div>
          <span className="text-sm font-medium">Connect to </span>
          <span className="text-sm font-bold">HubSpot</span>
        </div>
      </a>
    </button>
  );
}
